import { yupResolver } from "@hookform/resolvers/yup";
import { FormGroup } from "@itandi/itandi-bb-ui/FormGroup";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSettlementItems } from "~/hooks/useSettlementItems";
import type { NskResponse } from "~/models/Api";
import type { DealSettlementEdit } from "~/models/DealSettlement";
import {
	buildDefaultSettlement,
	validationSchemaSettlement
} from "~/models/DealSettlement";
import { isSuccess } from "~/utils/api/api_handler";
import { SettlementForm } from "../SettlementForm";
import { SettlementFormFooter } from "../SettlementFormFooter";

type Props = {
	billingType: "owner" | "rentee";
	handleCreate: (submitValue: DealSettlementEdit) => Promise<NskResponse>;
	mutateConstructions: () => Promise<void>;
};
export function SettlementAddForm({
	billingType,
	handleCreate,
	mutateConstructions
}: Props) {
	const { notify } = useNotification();
	const { data: settlementItems } = useSettlementItems().index();
	const methods = useForm<DealSettlementEdit>({
		defaultValues: buildDefaultSettlement(billingType),
		mode: "onBlur",
		resolver: yupResolver(validationSchemaSettlement)
	});
	const onClickSubmit = React.useCallback(() => {
		methods.handleSubmit(async () => {
			const response = await handleCreate(methods.getValues());
			if (isSuccess(response)) {
				await mutateConstructions();
				methods.reset();
				notify({ content: "追加しました。", variant: "success" });
				return;
			}
			notify({ content: "エラーが発生しました。", variant: "error" });
			methods.reset();
		})();
	}, [handleCreate, methods, mutateConstructions, notify]);
	if (settlementItems === null) return null;
	return (
		<FormProvider {...methods}>
			<FormGroup variant="vertical">
				<SettlementForm settlementItems={settlementItems} />
			</FormGroup>
			<SettlementFormFooter onClickSubmit={onClickSubmit} type="add" />
		</FormProvider>
	);
}
